import log from 'salvo-lite/log'
import axios from 'axios'

class LoadMore {
    constructor (theme, elem) {
        log.debug('LoadMore', 'Constructing', this)
        this._elem = elem
        this._loadMoreContainer = this._elem.querySelector('[data-load-more-container]')
        this._loadMoreButton = this._elem.querySelector('[data-load-more-button]')
        this._loadMoreGrid = this._elem.querySelector('[data-load-more-items]')
        this.offset = 50
        this.events = this.createEvents()
        this._isLoading = false
    }

    createEvents () {
        return {
            loaded: new Event('dataLoaded')
        }
    }

    onInit () {
        log.debug('LoadMore', 'Initiating')
        if (!this._loadMoreContainer) return false
        this._loadMoreButton.addEventListener('click', e => {
            e.preventDefault()
            this.loadMore()
        })
        this.scrollEvent()
        log.debug('LoadMore', 'Initiated')
    }

    scrollEvent () {
        window.addEventListener('scroll', (e) => {
            if (this._loadMoreContainer && (window.scrollY + window.innerHeight + this.offset) >= this._loadMoreContainer.offsetTop) {
                if (!this._isLoading) {
                    this.loadMore()
                }
            }
        })
    }

    loadMore () {
        if (this._isLoading || !this._loadMoreButton) return false
        log.debug('LoadMore', 'Load More Trigger Clicked!')
        let url = this._loadMoreButton.dataset.loadMoreUrl
        this._isLoading = true
        this._loadMoreButton.setAttribute('disabled', 'disabled')
        this._loadMoreContainer.classList.add('loading')
        axios.get(url)
            .then((response) => {
                let resp = response.data
                let parser = new DOMParser()
                let html = parser.parseFromString(resp, 'text/html')

                let data = html.querySelectorAll('[data-load-more-items] > *')
                let fragment = document.createDocumentFragment()

                for (let dataItem of data) {
                    fragment.appendChild(dataItem)
                }

                this._loadMoreGrid.appendChild(fragment.cloneNode(true))
                this._loadMoreContainer.classList.remove('loading')

                let loadMoreButton = html.querySelector('[data-load-more-container] [data-load-more-button]')

                if (loadMoreButton) {
                    this._loadMoreButton.dataset.loadMoreUrl = loadMoreButton.dataset.loadMoreUrl
                } else {
                    this._loadMoreContainer.parentNode.removeChild(this._loadMoreContainer)
                    this._loadMoreContainer = null
                    this._loadMoreButton = null
                }
                if (window.LineItems) {
                    window.LineItems.createInputFields()
                }
                this._elem.dispatchEvent(this.events.loaded)
                this._loadMoreButton.removeAttribute('disabled')
                this._isLoading = false
            })
            .catch((error) => {
                console.log(error)
                this._loadMoreButton.removeAttribute('disabled')
                this._isLoading = false
            })
    }
}

export default LoadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/LoadMore.js